import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import EntityHoverCard from './EntityHoverCard';
import { toEntityHoverProfile, type EntityHoverRow } from './toEntityHoverProfile';
import styles from './EntityHoverCard.module.scss';
import { HOVER_CARD_TOOLTIP_PROPS } from '../hoverCardTooltip.constants';

const CARD_CONTENT_CSS = { padding: 0, background: 'transparent', boxShadow: 'none', borderRadius: '0.5rem' };

/** Builds the profile only when the tooltip mounts its content, i.e. on hover. */
function EntityHoverCardContent({ row }: { row: EntityHoverRow }) {
    return <EntityHoverCard profile={toEntityHoverProfile(row)} />;
}

/** Mounts the company/LLP hover card on a Related Party name cell. */
function EntityHoverCardTooltip({ row, children }: { row: EntityHoverRow; children: React.ReactNode }) {
    return (
        <Tooltip
            {...HOVER_CARD_TOOLTIP_PROPS}
            content={<EntityHoverCardContent row={row} />}
            contentCss={CARD_CONTENT_CSS}
            flipToFit
            keepInScrollContainer
            verticalAlign="center"
            tipClassName={styles.HoverCardTip}
        >
            {children}
        </Tooltip>
    );
}

export default EntityHoverCardTooltip;
